<template>
  <div class="login-container">
    <!-- Logo Above the Form -->
    <div class="maxxifiedLogoContainer">
      <img :src="tenantConfigs?.logo ? tenantConfigs?.logo : maxxifiedLogo" class="newLogo" alt="" />
    </div>
    <p class="loginTitleNew">Validate Email and set up password</p>
    <p class="loginSuitTitleNew">Please verify your email and create a password</p>

    <div class="login-card2">
      <form @submit.prevent="handleSubmit" class="login-card-inner-section">
        <div style="margin-top: 05px">
          <!-- {{ email }} -->
          <custom-input :value="tempPassword" @update:value="tempPassword = $event" label="Enter Temporary Password" type="password" required placeholder="Please enter your Temporary Password" :error="errors.tempPassword" />
        </div>
        <div style="margin-top: 30px">
          <custom-input :value="newPassword" @update:value="newPassword = $event" label="New Password" type="password" required placeholder="Enter new password" :error="errors.newPassword" />
        </div>
        <div style="margin-top: 30px">
          <custom-input :value="confirmPassword" @update:value="confirmPassword = $event" label="Confirm Password" type="password" required placeholder="Confirm new password" :error="errors.confirmPassword" />
        </div>

        <div class="buttonDiv">
          <custom-button type="submit" :disabled="loading">
            {{ loading ? 'Verifying...' : 'Verify' }}
            <div v-if="loading" class="spinner-border text-white spinner-grow-sm" role="status"></div>
          </custom-button>
        </div>
      </form>
    </div>

    <p class="goBackLabel" @click="goBack">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M20 12H4M4 12L10 6M4 12L10 18" stroke="#32393E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      Back To Login
    </p>
    <Footer />
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/authStore'
import CustomInput from '../../components/CustomInput.vue'
import CustomButton from '../../components/CustomButton.vue'
import { post, get } from '@/utils/api'
import { showToast } from '@/utils/toast'
import maxxifiedLogo from '@/assets/maxxified_logo.png'
import Footer from '../../components/Footer.vue'
export default {
  data() {
    return {
      maxxifiedLogo,
      email: '',
      tempPassword: '',
      newPassword: '',
      confirmPassword: '',
      loading: false,
      tenantConfigs: {},
      errors: {
        tempPassword: '',
        newPassword: '',
        confirmPassword: '',
      },
    }
  },
  created() {
    this.email = this.$route.query.email?.replace(/\s/g, '+')
    localStorage.setItem('email', this.email)
    if (!this.email) {
      showToast({
        title: 'Invalid URL',
        message: 'The registration URL is invalid or missing email parameter',
        type: 'error',
      })
    } else {
      this.getTenantConfig()
    }
  },
  mounted() {
    document.title = 'Register'
    const encodedEmail = encodeURIComponent(this.email)
    if (encodedEmail) this.handleOnBasisOfUserStatus(encodedEmail)
  },
  components: {
    CustomInput,
    CustomButton,
    Footer,
  },
  computed: {
    auth() {
      return useAuthStore()
    },
  },
  methods: {
    async getTenantConfig() {
      try {
        const encodedEmail = encodeURIComponent(this.email)
        const response = await get(`public/tenant-config?key=email&value=${encodedEmail}`)

        if (response?.status !== 200 || !response.data?.data) {
          return
        }

        const config = response.data.data
        this.tenantConfigs = config

        const { selected_theme, theme_primary_color, theme_secondary_color, custom_primary_color, custom_secondary_color } = config

        const primary = selected_theme === 'Custom' ? custom_primary_color : theme_primary_color
        const secondary = selected_theme === 'Custom' ? custom_secondary_color : theme_secondary_color

        if (primary) localStorage.setItem('theme_primary_color', primary)
        if (secondary) localStorage.setItem('theme_secondary_color', secondary)
      } catch (error) {
      }
    },

    async handleOnBasisOfUserStatus(emailId) {
      try {
        const response = await get(`public/user-info?email=${emailId}`)

        if (response?.data && !response.data.error) {
          const user = response.data.data
          if (user.status === 'Active') {
            showToast({
              title: 'Error',
              message: `This user is already registered. Proceed to login.`,
              type: 'error',
            })

            this.$router.push('/login')
          }
        } else {
          showToast({
            title: 'Error',
            message: 'Failed to fetch user status.',
            type: 'error',
          })
        }
      } catch (error) {
        showToast({
          title: 'Error',
          message: 'An error occurred while fetching user status.',
          type: 'error',
        })
      } finally {
        // optional cleanup or modal close
        // this.closeConfirmModal()
      }
    },
    goBack() {
      this.$router.push('/login')
    },
    async handleSubmit() {
      if (this.loading) return

      // Clear all errors
      this.errors = {
        tempPassword: '',
        newPassword: '',
        confirmPassword: '',
      }

      // Validate fields
      if (!this.tempPassword?.trim()) {
        this.errors.tempPassword = 'Temporary password is required'
        return
      }

      if (!this.newPassword?.trim()) {
        this.errors.newPassword = 'New password is required'
        return
      }

      if (!this.confirmPassword?.trim()) {
        this.errors.confirmPassword = 'Please confirm your password'
        return
      }

      if (this.newPassword !== this.confirmPassword) {
        this.errors.confirmPassword = 'Passwords do not match'
        return
      }

      try {
        this.loading = true
        const response = await post('/auth/reset-temp-password', {
          email: this.email,
          tempPassword: this.tempPassword.trim(),
          newPassword: this.newPassword.trim(),
        })

        if (response?.data?.code === 200) {
          showToast({
            title: 'Success',
            message: 'Password updated successfully',
            type: 'success',
          })
          const session = response?.data?.data?.Session
          localStorage.setItem('session', session)
          const authResult = response.data.data.AuthenticationResult
          localStorage.setItem('AccessToken', authResult?.AccessToken)
          localStorage.setItem('IdToken', authResult?.IdToken)
          localStorage.setItem('RefreshToken', authResult?.RefreshToken)
          this.auth.AccessToken = authResult?.AccessToken
          this.auth.IdToken = authResult?.IdToken
          this.auth.RefreshToken = authResult?.RefreshToken

          this.$router.push('/otp-verification')
        } else {
          showToast({
            title: 'Error',
            message: response?.data?.message || 'Failed to update password',
            type: 'error',
          })
        }
      } catch (error) {
        // Check if error is related to temporary password
        if (error?.response?.data?.message?.toLowerCase().includes('temporary password')) {
          this.errors.tempPassword = 'Invalid temporary password'
        } else {
          showToast({
            title: 'Error',
            message: error?.response?.data?.message || 'Failed to update password',
            type: 'error',
          })
        }
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
@import '@/styles/login.css';
</style>
